import { StageStatus, TrainingDoctype } from '../course-assignments';
import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { CourseAssigneeCompletionStatus } from './getCourseAssignees';

export type User = {
   userid: number;
   name: string;
   avatar: string;
};

export type Quiz = {
   quiz_revisionid: number;
   quizid: number;
   modified_by: number;
   title: string;
   description: string;
   passing_score: number;
   deleted: number;
   date: number;
   quiz_json: Record<string, any>;
};

export type QuizSession = {
   quiz_sessionid: number;
   userid: number;
   quizid: number;
   quiz_revisionid: number;
   doctype: TrainingDoctype;
   docid: number;
   langid: string;
   doc_revisionid: number;
   response_json: string;
   init_date: number;
   end_date: number;
   score: number;
   passed: boolean;
   cancelled: boolean;
   last_modified: number;
};

export type SignoffTeam = {
   teamid: number;
   name: string;
   image: string;
};

export type StageCompletionStatus = StageStatus | 'not started';

export type Signoff = {
   stage_assessmentid: number;
   course_stageid: number;
   assessmenttype: string;
   assessmentid: number;
   skills_points_possible: number;
   quiz_passing_score: number | null;
   teamid_signer: number;
   signoffTeam: SignoffTeam | null;
   signoff_requestid: number;
   is_cancelled: boolean;
   userid_requestor: number;
   userid_requestee: number;
   work_log_entryid: number;
   response_value: boolean | null;
   response_feedback: string;
   response_acknowledged: boolean;
   created_at: number | null;
   completed_at: number | null;
   acknowledged_at: number | null;
   response_type: string;
   requestee_avatar: string | null;
};

export type CourseAssigneeStage = {
   doc_title: string;
   doc_url: string;
   docid: number;
   doctype: TrainingDoctype;
   completion_status: StageCompletionStatus;
   completion_date: number | null;
   due_date: number | null;
   work_log_entry_pdf_url: string | null;
   work_log_completion_date: number | null;
   attached_quiz: Quiz | null;
   quiz_session: QuizSession | null;
   quiz_attempts_remaining: number | null;
   signoff: Signoff | null;
};

export type CourseAssigneeResponse = {
   assigner: User | null;
   assignee: User | null;
   course_assignmentid: number;
   created_date: number | null;
   due_date: number | null;
   completion_status: CourseAssigneeCompletionStatus | null;
   completion_date: number | null;
   total_stages_complete: number;
   stages: CourseAssigneeStage[];
};

export async function getCourseAssignee(
   wikiid: number,
   userid: number,
   options: CommonRequestOptions
) {
   return await makeRequest('get', `/course_assignees/course/${wikiid}/user/${userid}`, {
      ...options,
   });
}
